<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button type="button" class="close" (click)="dismiss()">
    <span>&times;</span>
  </button>
</div>
<div class="modal-body">
  <app-core-image-slider
    [entityType]="entityType"
    [entityId]="entityId"
    [large]="true"
  ></app-core-image-slider>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-light" (click)="dismiss()">
    {{ "navigations.close" | translate }}
  </button>
</div>
